import { motion } from "framer-motion";
import { Car, Landmark, Plane, Camera, Hotel, Map } from "lucide-react";
import SectionHead from "./SectionHead";

const SERVICES = [
  { id: "fleet", icon: Car, title: "Luxury Fleet Rental", desc: "Chauffeur-driven premium SUVs, sedans and tempo travellers — sanitised, GPS-tracked and trip-ready.", span: "lg:col-span-2" },
  { id: "pilgrimage", icon: Landmark, title: "Pilgrimage Circuits", desc: "Jagannath Puri, Konark and Odisha's sacred heritage routes, planned end-to-end.", span: "" },
  { id: "airport", icon: Plane, title: "Airport & Station Transfers", desc: "On-time pickups and drops to Bhubaneswar, Visakhapatnam and beyond.", span: "" },
  { id: "sightseeing", icon: Camera, title: "Sightseeing Packages", desc: "Chilika's dolphins, Gopalpur's beaches, Koraput's waterfalls — curated day tours.", span: "" },
  { id: "hotels", icon: Hotel, title: "Hotel & Stay Booking", desc: "Handpicked stays matched to your route and budget, booked with your trip.", span: "" },
  { id: "custom", icon: Map, title: "Custom All-India Tours", desc: "Tell us the map in your head — we build the itinerary, vehicle and stays around it.", span: "lg:col-span-2" },
];

export default function Services() {
  return (
    <section id="services" className="mx-auto max-w-7xl px-4 py-24 sm:px-8 lg:px-16">
      <SectionHead
        overline="What we do"
        title="Every mile, taken care of"
        sub="One call covers the vehicle, the route, the stay and the stories in between."
      />
      <div data-testid="services-bento-grid" className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {SERVICES.map((s, i) => (
          <motion.article
            key={s.id}
            data-testid={`service-card-${s.id}`}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: (i % 4) * 0.08, ease: [0.16, 1, 0.3, 1] }}
            className={`gold-glow-hover rounded-2xl border border-white/10 bg-[#171F26] p-8 ${s.span}`}
          >
            <s.icon className="h-7 w-7 text-[#D4AF37]" strokeWidth={1.5} />
            <h3 className="mt-5 font-serif text-xl font-semibold">{s.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-white/60">{s.desc}</p>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
